import {
    FETCH_MONTHLY_BUDGET_BREAKDOWN
} from '../../actions/types';

const INITIAL_STATE = null;

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_MONTHLY_BUDGET_BREAKDOWN:
            return action.payload;
        default:
            return state;
    }
};